import {useRef} from 'react'

import {useSuiContext} from '@s-ui/react-context'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'
import {Button, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {ICON_SIZES} from '@adv-mt/ui/icon'
import {PLACEMENTS, Popover, PopoverClose, PopoverContent, PopoverTrigger} from '@adv-mt/ui/popover'
import {Body1, Body2} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-contact-bannerInfo`

const BannerInfo = () => {
  const barRef = useRef(null)
  const {i18n} = useSuiContext()

  const text = i18n.t('COMMON.DETAIL_CANARIAS_BANNER_TEXT_SHORT')
  const tooltipTitle = i18n.t('COMMON.DETAIL_CANARIAS_BANNER_TOOLTIP_TITLE')
  const tooltipBody = i18n.t('COMMON.DETAIL_CANARIAS_BANNER_TOOLTIP_BODY')

  return (
    <Popover>
      <div ref={barRef} className={`${BASE_CLASS}-bar`}>
        <span aria-hidden="true">{'📍'}</span>
        <Body2 className={`${BASE_CLASS}-text`}>{text}</Body2>
        <PopoverTrigger
          render={
            <Button
              aria-label={tooltipTitle}
              shape={BUTTON_SHAPES.CIRCLE}
              size={BUTTON_SIZES.MEDIUM}
              variant={BUTTON_VARIANTS.FLAT}
            />
          }
        >
          <IconInfoOutline size={ICON_SIZES.SM} />
        </PopoverTrigger>
      </div>
      <PopoverContent
        anchor={barRef}
        className={`${BASE_CLASS}-popoverContent`}
        placement={PLACEMENTS.TOP}
        showCaret={false}
      >
        <div className={`${BASE_CLASS}-popoverHeader`}>
          <Body1 className={`${BASE_CLASS}-popoverTitle`} highlight>
            {tooltipTitle}
          </Body1>
          <PopoverClose
            render={
              <Button
                aria-label={i18n.t('COMMON_CLOSE')}
                negative
                shape={BUTTON_SHAPES.CIRCLE}
                size={BUTTON_SIZES.MEDIUM}
                variant={BUTTON_VARIANTS.FLAT}
              />
            }
          >
            <IconClose size={ICON_SIZES.SM} />
          </PopoverClose>
        </div>
        <Body2 className={`${BASE_CLASS}-popoverBody`}>{tooltipBody}</Body2>
      </PopoverContent>
    </Popover>
  )
}

BannerInfo.displayName = 'BannerInfo'

BannerInfo.propTypes = {}

export default BannerInfo
